import React, { useState } from 'react'
import { FormGroup, FormControlLabel, Checkbox, TextField, Button } from '@material-ui/core'
import styled from '@emotion/styled'
import css from '@emotion/css'
import { colors, fonts, breakpoints } from '../../../styles/variables'
import { getEmSize } from '../../../styles/mixins'

const CheckboxWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    flex-direction: column;
    margin-bottom: 20px;
  }
`

const StyledCheckbox = styled(Checkbox)`
  color: ${colors.white};
  svg {
    fill: ${colors.white};
  }
  &.Mui-checked {
    svg {
      fill: ${colors.red};
    }
  }
`

const SubmitButton = styled(Button)`
  background-color: ${colors.red};
  width: 200px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-top: 30px;
  &:hover,
  &:focus {
    background-color: ${colors.darkRed};
  }
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    width: 100%;
    margin-bottom: 30px;
  }
`

const StyledTextField = styled(TextField)`
  width: 100%;
  background-color: ${colors.white};
  border-radius: 5px;
`

const StyledFormControlLabel = styled(FormControlLabel)`
  color: ${colors.white};
  span {
    font-family: ${fonts.sansSerif};
    font-size: 20px;
    font-weight: 600;
  }
  margin-bottom: 10px;
`

const StyledFormGroup = styled(FormGroup)`
  margin-right: 30px;
`

export default function JoinTheMovement() {
  const [contributions, setContributions] = useState({
    doors: false,
    calls: false,
    texts: false,
    host: false,
    voter: false,
    event: false,
    contribution: '',
    name: '',
    email: '',
    zip: '',
    phone: ''
  })
  return (
    <>
      <CheckboxWrapper>
        <StyledFormGroup>
          <StyledFormControlLabel
            control={
              <StyledCheckbox
                checked={contributions.doors}
                onChange={() => setContributions({ ...contributions, doors: !contributions.doors })}
                value="doors"
              />
            }
            label="Knock Doors"
          />
          <StyledFormControlLabel
            control={
              <StyledCheckbox
                checked={contributions.calls}
                onChange={() => setContributions({ ...contributions, calls: !contributions.calls })}
                value="calls"
              />
            }
            label="Make Calls"
          />
          <StyledFormControlLabel
            control={
              <StyledCheckbox
                checked={contributions.texts}
                onChange={() => setContributions({ ...contributions, texts: !contributions.texts })}
                value="texts"
              />
            }
            label="Send Texts"
          />
        </StyledFormGroup>
        <StyledFormGroup>
          <StyledFormControlLabel
            control={
              <StyledCheckbox
                checked={contributions.host}
                onChange={() => setContributions({ ...contributions, host: !contributions.host })}
                value="host"
              />
            }
            label="Host a Fundraiser"
          />
          <StyledFormControlLabel
            control={
              <StyledCheckbox
                checked={contributions.voter}
                onChange={() => setContributions({ ...contributions, voter: !contributions.voter })}
                value="voter"
              />
            }
            label="Voter Registration"
          />
          <StyledFormControlLabel
            control={
              <StyledCheckbox
                checked={contributions.event}
                onChange={() => setContributions({ ...contributions, event: !contributions.event })}
                value="event"
              />
            }
            label="Organize an Event"
          />
        </StyledFormGroup>
      </CheckboxWrapper>
      <p
        css={css`
          color: ${colors.white};
          margin-bottom: 0;
        `}
      >
        Contribute in a way that's not listed:
      </p>
      <StyledTextField
        label="Tell us here"
        value={contributions.contribution}
        onChange={(e: any) => setContributions({ ...contributions, contribution: e.target.value })}
        margin="normal"
        variant="filled"
        style={{ marginTop: 5, marginBottom: 22 }}
      />
      <StyledTextField
        label="Name"
        value={contributions.name}
        onChange={(e: any) => setContributions({ ...contributions, name: e.target.value })}
        margin="normal"
        variant="filled"
      />
      <StyledTextField
        label="Email"
        value={contributions.email}
        onChange={(e: any) => setContributions({ ...contributions, email: e.target.value })}
        margin="normal"
        variant="filled"
      />
      <div style={{ display: 'flex' }}>
        <StyledTextField
          label="Phone"
          value={contributions.phone}
          onChange={(e: any) => setContributions({ ...contributions, phone: e.target.value })}
          margin="normal"
          variant="filled"
          style={{ marginRight: 15 }}
        />
        <StyledTextField
          label="Zip"
          value={contributions.zip}
          onChange={(e: any) => setContributions({ ...contributions, zip: e.target.value })}
          margin="normal"
          variant="filled"
        />
      </div>
      <form
        name="join-the-movement"
        method="post"
        action="/joined#thanks-for-joining"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
      >
        {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
        <input type="hidden" name="form-name" value="join-the-movement" />
        <input type="hidden" name="name" value={contributions.name} />
        <input type="hidden" name="Knock Doors" value={contributions.doors} />
        <input type="hidden" name="Make Calls" value={contributions.calls} />
        <input type="hidden" name="Send Texts" value={contributions.texts} />
        <input type="hidden" name="Host a Fundraiser" value={contributions.host} />
        <input type="hidden" name="Voter Registration" value={contributions.voter} />
        <input type="hidden" name="Organize an Event" value={contributions.event} />
        <input type="hidden" name="Contribute in a way thats not listed" value={contributions.contribution} />
        <input type="hidden" name="phone" value={contributions.phone} />
        <input type="hidden" name="email" value={contributions.email} />
        <input type="hidden" name="zip" value={contributions.zip} />
        <SubmitButton type="submit">JOIN</SubmitButton>
      </form>
    </>
  )
}
